import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { collections } from '@services/api'

import { collectionClinicServices } from '@services/api'
export class collectionsStore extends StoreExt {
    @observable loading = false
    @observable editCollection = {}
    @observable collection = {}
    @observable list = []
    @observable filters = {}
    @observable categories = []
    @observable errors = {}
    @observable paging = {
        page: 1,
        perPage: 0,
        total: 0,
        lastPage: 0,
        filters: {}
    }

    @action
    getCollections = async page => {
        this.loading = true
        const { perPage, total, lastPage, data } = (await collections.getList({ ...this.filters, page })).data
        const filters = { ...this.filters }
        runInAction(() => {
            this.list = data
            this.paging = { perPage, total, page, lastPage, filters }
            this.loading = false
        })
    }

    @action
    search = async params => {
        this.loading = true
        const { keywords, page } = params
        const { collections: list, total } = (await collections.search({ keywords, page })).data
        runInAction(() => {
            this.list = list
            this.paging['total'] = total
            this.paging['page'] = page
            this.loading = false
        })
    }

    @action
    getCollectionsByClinic = async (id, page, perPage) => {
        this.loading = true

        var res = (await collectionClinicServices.list({ clinic_id: id, ...this.filters, page, perPage })).data
        const filters = { ...this.filters }
        runInAction(() => {
            this.list = res.list
            this.paging = { perPage: res.perPage, total: res.total, page: res.page, lastPage: res.lastPage, filters }
            this.loading = false
        })
    }

    @action
    getCollection = async id => {
        this.loading = true
        const { collection } = (await collections.getCollection({ id })).data
        runInAction(() => {
            this.collection = collection
            this.editCollection = collection
            this.loading = false
        })
    }

    @action
    addCollection = async () => {
        this.loading = true
        this.resetErrors()
        if (!('name' in this.editCollection) || !!!this.editCollection['name']) {
            this.setError({ nameError: 'חובה להזין שם זכות' })
        } else {
            await collections
                .addCollection(this.editCollection)
                .then(res => {
                    runInAction(() => {
                        this.editCollection = res.data
                    })
                    this.updateAll()
                })
                .catch(e => {
                    if (e.response.status) {
                        this.setError({ nameError: 'שם זכות זו כבר קיים או שאינו תקין' })
                    } else {
                        this.setError({ serverError: 'אירעה שגיאה במהלך עדכון הזכות' })
                    }
                })
        }
    }

    @action
    updateCollection = async () => {
        this.loading = true
        this.resetErrors()
        if (!('name' in this.editCollection) || !!!this.editCollection['name']) {
            this.setError({ nameError: 'חובה להזין שם זכות' })
        } else {
            collections
                .updateCollection(this.editCollection)
                .then(res => {
                    this.updateAll()
                })
                .catch(e => {
                    if (e.response.status) {
                        this.setError({ nameError: 'שם זכות זו כבר קיים או שאינו תקין' })
                    } else {
                        this.setError({ serverError: 'אירעה שגיאה במהלך עדכון הזכות' })
                    }
                })
        }
    }

    @action
    setError = error => {
        const prevErrors = { ...this.errors }
        this.errors = { prevErrors, ...error }
        this.loading = false
    }

    @action
    resetErrors = () => {
        this.errors = {}
    }

    @action
    deleteCollection = async () => {
        this.loading = true
        await collections.deleteCollection(this.editCollection['id'])
        await this.getCollections(1)
        runInAction(() => {
            this.collection = {}
            this.editCollection = {}
            this.loading = false
        })
    }

    @action
    addCategory = async category_id => {
        this.loading = true
        await collections.addCategory({ category_id, id: this.editCollection['id'] })
        this.updateAll()
    }

    @action
    deleteCategory = async category_id => {
        this.loading = true
        await collections.deleteCategory({ category_id, id: this.editCollection['id'] })
        this.updateAll()
    }

    @action
    addServicefield = async servicefield_id => {
        this.loading = true
        await collections.addServiceField({ servicefield_id, id: this.editCollection['id'] })
        this.updateAll()
    }

    @action
    deleteServicefield = async servicefield_id => {
        this.loading = true
        await collections.deleteServiceField({ servicefield_id, id: this.editCollection['id'] })
        this.updateAll()
    }

    @action
    updateAll = async () => {
        await this.getCollection(this.editCollection['id'])
        await this.getCollections(this.paging.page)
        runInAction(() => {
            this.loading = false
        })
    }

    @action
    editField = (name, value) => {
        this.editCollection[name] = value
    }

    @action
    resetCollection = () => {
        this.collection = {}
        this.editCollection = {}
    }

    @action
    changePage = page => {
        this.loading = true
        const filters = this.paging.filters
        runInAction(() => {
            this.paging.page = page
            this.filters = filters
            // this.getCollections(page)
        })
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }

    @action
    resetFilters = () => {
        this.filters = {}
    }
}

export default remotedev(new collectionsStore())
